import { render, staticRenderFns } from "./Accessories-Archived.vue?vue&type=template&id=3f9db213&scoped=true&"
import script from "./Accessories-Archived.vue?vue&type=script&lang=js&"
export * from "./Accessories-Archived.vue?vue&type=script&lang=js&"
import style0 from "./Accessories-Archived.vue?vue&type=style&index=0&id=3f9db213&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9db213",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VIcon,VProgressCircular,VRow})
